import { type FC } from 'react'
import { Link } from '../Link'
import styled from 'styled-components'
import { mq, vw } from '@/styles'

type Props = {
  color: string
}

export const Logo:FC<Props> = ({ color }) => {

  return (
    <LinkStyled href='/' className='l--logo' title='Nexia homepage'>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 93 28'><path d='M36.43 6.44c3.16 0 5.71 1.16 7.39 3.37 1.36 1.8 2.12 4.24 2.12 6.87 0 .69-.05 1.15-.05 1.17-.01.06-.05.1-.11.1h0-16.27c.14 2.07.82 3.81 1.96 5.04 1.21 1.31 2.91 2.01 4.9 2.01 2.98 0 5.05-1.33 6.16-3.96h0l.12-.28c.02-.04.06-.07.11-.07h0 2.89c.04 0 .07.02.09.05s.03.07.02.11h0l-.21.61c-1.38 3.98-4.84 6.35-9.25 6.35-6.13 0-9.94-4.09-9.94-10.67 0-6.39 4.05-10.67 10.09-10.67zm47.91 0c2.64 0 4.53.71 5.77 2.16 1.23 1.44 1.81 3.63 1.81 6.69h0v.27l-.04 5.94c0 2.56.08 3.9.61 5.66.02.03.01.08-.01.11s-.06.05-.1.05h0-2.95c-.05 0-.09-.03-.11-.08-.19-.72-.26-1.35-.29-2.3-1.46 1.75-3.82 2.78-6.61 2.78-4.31 0-6.98-2.31-6.98-6.03 0-4.38 4.4-5.46 8.9-6.2l3.02-.42.48-.06.94-.1c-.06-2.07-.44-3.51-1.18-4.39-.71-.84-1.8-1.24-3.43-1.24-2.88 0-4.62 1.5-4.77 4.1h0l-.03.43c0 .06-.05.11-.11.11h0-2.91c-.06 0-.11-.05-.11-.12h0v-.46c0-4 3.4-6.91 8.08-6.91zm-34 .51c.04 0 .07.02.09.04h0l.19.25c.32.44 3.41 4.29 6.73 8.42l.51.64.26.32.51.64 6.39 7.94h0l-.09.07.09-.07.01.02 1.72 1.9c.03.04.04.08.02.13s-.06.07-.11.07h0-3.71c-.03 0-.07-.02-.09-.04h0l-.21-.26L46.48 7.14c-.03-.03-.03-.08-.01-.12s.06-.07.1-.07h0zM3.5 0c.04 0 .07.02.09.05h0l16.14 22.57-.02-1.47h0v-.02l-.01-.89-.01-.91-.04-3.69V.12c0-.06.05-.12.11-.12h0 2.9c.06 0 .12.05.12.12h0V27.2c0 .07-.05.11-.12.11h0-3.22c-.04 0-.07-.02-.09-.05h0L3.04 4.45l.04 2.52.09 6.7h0V27.2c0 .07-.05.11-.12.11h0H.12c-.06 0-.12-.05-.12-.11h0V.12C0 .05.05 0 .12 0h0zm68.52 6.95c.06 0 .11.05.11.11h0V27.2c0 .07-.05.11-.11.11h0-2.94c-.06 0-.11-.05-.11-.11h0V7.07c0-.06.05-.11.11-.11h0zM54.16 19.82c.03 0 .06.04.05.07h0L50.61 27l-.11.25c-.02.04-.06.07-.11.07h0-4.44c-.05 0-.09-.03-.11-.07s-.01-.1.03-.13h0l7.87-7.27c.02-.02.05-.03.07-.03h0zm34.69-2.17c-1.66.19-3.26.37-4.63.62-5.08.98-5.49 2.13-5.49 3.42 0 2.1 1.54 3.3 4.22 3.3 3.75 0 5.9-2.47 5.9-6.78v-.56zM36.35 9.2c-1.85 0-3.46.58-4.64 1.67-1.11 1.03-1.83 2.5-2.08 4.27h0 13.04c-.18-1.71-.78-3.15-1.75-4.17-1.11-1.16-2.69-1.78-4.58-1.78zM66.4 6.95c.05 0 .09.03.11.07s0 .1-.03.13l-7.8 7.16c-.03.03-.05.03-.08.03h0-.31c-.06 0-.09-.06-.07-.11h0l3.52-6.96.11-.25c.02-.04.06-.07.11-.07h0zm5.61-5.69c.06 0 .11.05.11.12h0v2.94c0 .06-.05.11-.11.11h0-2.94c-.06 0-.11-.05-.11-.11h0V1.38c0-.06.05-.11.11-.11h0z' fill={color} fillRule='evenodd' /></svg>
    </LinkStyled>
  )
}

const LinkStyled = styled(Link)`
  align-items: center;
  display: flex;
  grid-column: 3 / span 2;
  grid-row: 1 / span 1;
  height: 100%;
  justify-content: center;
  width: 100%;

  ${mq.greaterThan('tablet')} {
    grid-column: 6 / span 2;
  }

  svg {
    width: ${vw(67, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      width: ${vw(67, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      width: ${vw(93, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      width: 93px;
    }
  }
`